import {Component, effect, inject, OnInit, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IonButton, IonIcon, IonSelect, IonSelectOption} from '@ionic/angular/standalone';
import {PropertyService} from '../../properties/property.service';
import {components} from '../../configs/config';
import {LanguageService} from '../../core/language.service';
import {FilterService} from '../filter/filter.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-header-filter',
  templateUrl: './header-filter.component.html',
  styleUrls: ['./header-filter.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    FormsModule,
    IonButton,
    IonIcon,
    IonSelect,
    IonSelectOption,
    ReactiveFormsModule
  ],
  standalone: true
})
export class HeaderFilterComponent  implements OnInit {
  propertyService: PropertyService = inject(PropertyService);
  languageService: LanguageService = inject(LanguageService);
  content: any;

  filterForm: FormGroup = new FormGroup({
    city: new FormControl(),
    beds: new FormControl(0),
    baths: new FormControl(0),
    sub: new FormControl(''),
    category: new FormControl(''),
    unfurnished: new FormControl(),
    partiallyFurnished: new FormControl(),
    fullyFurnished: new FormControl(),
    withAppliances: new FormControl(),
    withOutAppliances: new FormControl(),
  });
  filterService: FilterService = inject(FilterService);
  router: Router = inject(Router);
  constructor() {
    effect(() => {
      if (this.filterService.filterData()) {
        const data = this.filterService.filterData();
        this.filterForm.patchValue({
          sub: data.sub,
          city: data.city,
          }, {emitEvent: false});
      }
    });
  }

  async ngOnInit() {

    if (this.languageService.lang()) {
      this.content = await this.languageService.loadContent(components.filters);
    }
  }
  filterProperties() {
    const  values: any = {}; // this.filterForm.value;
    if (this.propertyService.selectedCategory()) {
      values.subCatId = this.filterForm.value.category;
    }
    if (this.filterForm.value.beds === 0) {
      delete this.filterForm.value.beds;
    }
    if (this.filterForm.value.baths === 0) {
      delete this.filterForm.value.baths;
    }
    if (!this.filterForm.value.sub) {
      delete this.filterForm.value.sub;
    }
    if (!this.filterForm.value.category) {
      delete this.filterForm.value.category;
    }
    this.filterService.filterData.set({...values, ...this.filterForm.value})

    this.router.navigate(['/listings', 'filter'], {queryParams: {...values, ...this.filterForm.value} });
  }


}
